import { useTranslation } from "react-i18next";

import {
  IPlaceInfoLandingModel,
  WestNegevChooseStationStepFormFieldsEnum,
  yupLanding,
} from "@ryde/utils-landings";

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useYupChooseStationLandingValidationSchema = () => {
  const { t } = useTranslation();
  const yupChooseStationLandingValidationSchema = {
    [WestNegevChooseStationStepFormFieldsEnum.SiteId]: yupLanding
      .number()
      .required(),
    [WestNegevChooseStationStepFormFieldsEnum.Age]: yupLanding
      .string()
      .required(),
    [WestNegevChooseStationStepFormFieldsEnum.FirstName]: yupLanding
      .string()
      .required(),
    [WestNegevChooseStationStepFormFieldsEnum.LastName]: yupLanding
      .string()
      .required(),
    [WestNegevChooseStationStepFormFieldsEnum.PhoneMobile]: yupLanding
      .string()
      .required(),
    [WestNegevChooseStationStepFormFieldsEnum.PreferredStationId]: yupLanding
      .number()
      .required(),
    [WestNegevChooseStationStepFormFieldsEnum.HomeAddress]: yupLanding
      .object<IPlaceInfoLandingModel>()
      .shape({
        fullAddress: yupLanding.string().optional(),
        latitude: yupLanding.number().nullable().optional(),
        longitude: yupLanding.number().nullable().optional(),
      })
      .optional(),
    [WestNegevChooseStationStepFormFieldsEnum.SourceStation2Id]: yupLanding
      .number()
      .optional(),
    [WestNegevChooseStationStepFormFieldsEnum.DestinationId]: yupLanding
      .number()
      .required(),
    [WestNegevChooseStationStepFormFieldsEnum.AcceptTerms]: yupLanding
      .boolean()
      .oneOf([true], t("landing.validation.acceptTermsRequired")),
    [WestNegevChooseStationStepFormFieldsEnum.AcceptPrivacyPolicy]: yupLanding
      .boolean()
      .oneOf([true], t("landing.validation.acceptPrivacyPolicyRequired")),
  };

  return {
    yupChooseStationLandingValidationSchema,
  };
};
